import { useEffect, useState } from "react";
import { fetchCarMakes, fetchCarModels, fetchCarYears } from "../../services/api";
import Button from "../Button/Button";
import Card from "../Card/Card";
import Select from "../Select/Select";

import './CarSelection.scss';

const CarSelection = props => {


    const params = new URLSearchParams(window.location.search);

    const [make, setMake] = useState(null);
    const [model, setModel] = useState(null);
    const [year, setYear] = useState(null);
    const [oem, setOem] = useState(params.get('oem'));

    const [modelOptions, setModelOptions] = useState([]);
    const [yearOptions, setYearOptions] = useState([]);
    const [makeOptions, setMakeOptions] = useState([]);

    useEffect(() => {
        fetchCarMakes().then(makes => {
            setMakeOptions(makes);
        })
    }, []);

    useEffect(() => {
        if (make) {
            setModel(null);
            setYear(null);
            setModelOptions([]);
            setYearOptions([]);
            fetchCarModels(make).then(models => {
                setModelOptions(models);
            })
        }
    }, [make])

    useEffect(() => {
        if (make && model) {
            setYear(null);
            setYearOptions([]);
            fetchCarYears(make, model).then(years => {
                setYearOptions(years);
                if (years.length === 1) {
                    setYear(years[0].name)
                }
            })
        }
    }, [model])
    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 700);


    useEffect(() => {
        const handleResize = () => {
            setIsDesktop(window.innerWidth > 700);

        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <Card className={`car-selection-card-container ${props.sticky?'sticky':''} ${(params.get('tmpl')==='t2' && isDesktop)?'marginfix':''}`} >
            {
                props.header && 
                <div className="car-selection-header">{props.header}</div>
            }
            <div className={`flex form-container ${props.vertical?'vertical':''}`}>
                <Select className="select flex-1" options={makeOptions} label="Make" onChange={(option) => {
                    setMake(option.name);
                    window.dataLayer.push({
                        'event': 'Selected make'
                    })
                }}></Select>
                <Select className={`select flex-1 ${!modelOptions.length ? 'disabled' : ''}`} options={modelOptions} label="Model" onChange={(option) => {
                    setModel(option.name);
                    setOem(option.oem)
                    window.dataLayer.push({
                        'event': 'Selected model'
                    })
                }}></Select>
                <Select className={`select flex-1 ${!yearOptions.length ? 'disabled' : ''}`} options={yearOptions} label="Year" selected={year} onChange={(option) => {
                    setYear(option.name);
                    window.dataLayer.push({
                        'event': 'Selected year'
                    })
                }}></Select>
                <Button className={"xl primary cta button-icon " + ((!make || !model || !year) && 'disabled ')} onClick={() => {
                    if (make && model && year) {
                        params.set('make', make);
                        params.set('model', model);
                        params.set('year', year);
                        params.set('oem', oem);

                        props.ctaClicked(params)
                        
                    }

                }}><span className="icon icon-Search"></span>Search Dealers</Button>
            </div>
        </Card>

    )
}

export default CarSelection